/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Embed_Captions_Important_TotalInputs */

const en_embed_captions_important_total = /** @type {(inputs: Embed_Captions_Important_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total cost for this job will be ${i?.total}.`)
};

const fr_embed_captions_important_total = /** @type {(inputs: Embed_Captions_Important_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le cout total de cette tache sera de ${i?.total}.`)
};

const de_embed_captions_important_total = /** @type {(inputs: Embed_Captions_Important_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Gesamtkosten für diesen Auftrag betragen ${i?.total}.`)
};

const it_embed_captions_important_total = /** @type {(inputs: Embed_Captions_Important_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il costo totale per questo lavoro sarà di ${i?.total}.`)
};

const ru_embed_captions_important_total = /** @type {(inputs: Embed_Captions_Important_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Общая стоимость этой работы составит ${i?.total}.`)
};

const es_embed_captions_important_total = /** @type {(inputs: Embed_Captions_Important_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El costo total de este trabajo será ${i?.total}.`)
};

const zh_cn2_embed_captions_important_total = /** @type {(inputs: Embed_Captions_Important_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`这项工作的总成本为${i?.total}。`)
};

const ja_embed_captions_important_total = /** @type {(inputs: Embed_Captions_Important_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この仕事の合計費用は${i?.total}になります。`)
};

const hi_embed_captions_important_total = /** @type {(inputs: Embed_Captions_Important_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इस कार्य की कुल लागत ${i?.total} होगी।`)
};

const pt_pt2_embed_captions_important_total = /** @type {(inputs: Embed_Captions_Important_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O custo total deste trabalho será de ${i?.total}.`)
};

/**
* | output |
* | --- |
* | "Total cost for this job will be {total}." |
*
* @param {Embed_Captions_Important_TotalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_important_total = /** @type {((inputs: Embed_Captions_Important_TotalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Important_TotalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_important_total(inputs)
	if (locale === "de") return de_embed_captions_important_total(inputs)
	if (locale === "it") return it_embed_captions_important_total(inputs)
	if (locale === "ru") return ru_embed_captions_important_total(inputs)
	if (locale === "es") return es_embed_captions_important_total(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_important_total(inputs)
	if (locale === "ja") return ja_embed_captions_important_total(inputs)
	if (locale === "hi") return hi_embed_captions_important_total(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_important_total(inputs)
	return en_embed_captions_important_total(inputs)
});